module.exports = __webpack_public_path__ + "static/media/alair-avd.9e2b6ae8.png";